<template>
    <div id="memberact">
        <Banner title="會員專區" :breadcrumbs="breadcrumbs" type="member"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Activity payment Record" chtFirst="活動" chtSecond="報名紀錄" :center="true"></Title>
            </div>
            <section class="content" v-if="!eventId">
                <div class="global_title nomb">已報名活動</div>
                <div class="remark" v-if="activitys.length == 0">
                    <span>暫無已報名活動</span>
                </div>
                <div
                    class="box"
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                >
                    <a
                        class="item"
                        v-for="(item,index) in activitys"
                        :key="index"
                        :href="`/Member/Record?Id=${item.Id}`"
                        title="查看活動資訊"
                    >
                        <div class="img">
                            <img :src="item.Image || require('@/assets/default-small.png')" />
                        </div>
                        <div class="info">
                            <div class="title">{{item.Title}}</div>
                            <div
                                class="date"
                            >活動開始日期:{{$moment(item.StartOn).locale('zh-tw').format("LL")}}</div>
                            <div class="time">是否繳費:{{item.IsPaid?"已繳費":"未繳費"}}</div>
                            <div class="money">報名費用:{{item.TotalAmount}}元</div>
                        </div>
                        <div class="btn_box">
                            <div class="item">
                                <div class="Orange_btn islogin">
                                    <a href="javascript:;" @click="openMemo(index,item.Memo)">繳費資訊</a>
                                </div>
                            </div>
                            <div class="item print" v-if="item.IsPaid && item.TotalAmount > 0 && ((new Date() - new Date(item.StartOn))/(1000*60*60*24)) < 365 ">
                                <div class="Orange_btn islogin">
                                    <a href="javascript:;" @click="printData(item.Id)">列印收據</a>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="memo" ref="memo" v-html="item.Memo">{{}}</div> -->
                    </a>
                </div>
            </section>
            <section class="content" v-if="eventId">
                <div class="detail">
                    <div class="global_title nomb">活動基本資訊</div>
                    <div class="act">
                        <div class="title">{{eventDetail.Title}}</div>
                        <div class="info">
                            <div class="img">
                                <img
                                    :src="eventDetail.Image || require('@/assets/default-small.png')"
                                    :alt="eventDetail.Title"
                                />
                            </div>
                            <ul class="text">
                                <li>中華民國視網膜醫學會</li>
                                <li>服務專線:0965-106869</li>
                                <li>日期:{{$moment(eventDetail.StartOn).locale('zh-tw').format("LL") + "~" + $moment(eventDetail.EndOn).locale('zh-tw').format("LL")}}</li>
                                <li>地點:{{eventDetail.Location}}</li>
                                <li>主辦:{{eventDetail.Organizer}}</li>
                                <li>協辦:{{eventDetail.CoOrganizer}}</li>
                            </ul>
                            <div class="btn_box">
                                <div class="Orange_btn islogin">
                                    <a :href="`/Event/Index?Id=${memberInfo.ActivityId}`">活動詳情</a>
                                </div>
                            </div>
                        </div>
                        <div class="btn_box"></div>
                    </div>
                    <div class="global_title nomb">報名人資訊</div>
                    <div class="member">
                        <div class="text_span">
                            <span>中文姓名</span>
                            <span>{{memberInfo.Name}}</span>
                        </div>
                        <div class="text_span">
                            <span>英文姓名</span>
                            <span>{{memberInfo.EngName}}</span>
                        </div>
                        <div class="text_span">
                            <span>聯絡電話</span>
                            <span>{{memberInfo.Mobile}}</span>
                        </div>
                        <div class="text_span">
                            <span>E-mail</span>
                            <span>{{memberInfo.Email}}</span>
                        </div>
                        <div class="text_span">
                            <span>服務單位</span>
                            <span>{{memberInfo.Affiliation}}</span>
                        </div>
                        <div class="text_span">
                            <span>職稱</span>
                            <span>{{memberInfo.Position}}</span>
                        </div>
                        <div class="text_span">
                            <span>稱謂</span>
                            <span>{{memberInfo.Title}}</span>
                        </div>
                        <div class="text_span">
                            <span>葷素類別</span>
                            <span>{{memberInfo.IsVegetarian?'素':'葷'}}</span>
                        </div>
                        <div class="text_span">
                            <span>晚宴</span>
                            <span>{{memberInfo.IsAttendDinner?'參加':'不參加'}}</span>
                        </div>
                    </div>
                    <div class="global_title nomb" v-if="memberInfo.Companions.length > 0">
                        隨行朋友
                        <span>總人數 : {{memberInfo.Companions.length}}</span>
                    </div>
                    <div class="friend">
                        <div
                            class="item"
                            v-for="(friend,index) in memberInfo.Companions"
                            :key="index"
                        >
                            <div class="title">隨行親友{{index + 1 }}</div>
                            <div class="text_span">
                                <span>中文姓名</span>
                                <span>{{friend.Name}}</span>
                            </div>
                            <div class="text_span">
                                <span>英文姓名</span>
                                <span>{{friend.EngName}}</span>
                            </div>
                            <div class="text_span">
                                <span>稱謂</span>
                                <span>{{friend.Title}}</span>
                            </div>
                            <div class="text_span">
                                <span>葷素類別</span>
                                <span>{{friend.IsVegetarian?'素':'葷'}}</span>
                            </div>
                            <div class="text_span">
                                <span>晚宴</span>
                                <span>{{friend.IsAttendDinner?'參加':'不參加'}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="global_title nomb">報名費</div>
                    <div class="cost">
                        <div class="title">報名訊息</div>
                        <ul class="signtpye">
                            <li>
                                <span>{{who}}</span>
                            </li>
                            <li>
                                <span>隨同親友即其他({{memberInfo.Companions.length}}名)</span>
                            </li>
                        </ul>
                    </div>
                    <div class="global_title nomb"></div>
                    <div class="total">
                        <span>總計</span>
                        <span>NTD {{eventDetail.TotalAmount}}</span>
                    </div>
                </div>
            </section>
            <graybtn />
        </div>
    </div>
</template>

<script>
import Common from "@/common";
import API from "@/service/member.js";
export default {
    name: "memberact",
    components: {},
    props: ["propactivityorders"],
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "會員專區"
                },
                {
                    url: "/Member/Record",
                    title: "活動報名紀錄"
                }
            ],
            activitys: [
                // {
                //     Id: 16,
                //     Number: "RSA000000016",
                //     IsPaid: true,
                //     TotalAmount: 123.0,
                //     Title: "testtest*-helen",
                //     Image: "",
                //     Location: null,
                //     Organizer: null,
                //     CoOrganizer: null,
                //     Memo:
                //         "特惠價視網膜醫學會會員 123.00PaymentType:ATM_CATHAY繳費銀行代碼:013繳費虛擬帳號:2803092045016879繳費期限:2019/09/20繳費金額:123",
                //     StartOn: "2019-09-16T00:00:00",
                //     EndOn: "2019-09-30T00:00:00"
                // }
            ],
            Page: 1,
            Count: 10,
            Totalpage: 1,
            busy: false,
            eventId: "",
            eventDetail: {},
            memberInfo: {}
        };
    },
    methods: {
        loadMore() {
            const vm = this;
            vm.busy = true;
            if (vm.Totalpage == 1 || vm.Totalpage == vm.Page) {
                return false;
            }
            vm.Page += 1;
            API.getActivityOrders({ leaf: vm.Page, count: vm.Count }).then(
                result => {
                    if (result.Data.Orders.length === 0) {
                        return false;
                    } else {
                        setTimeout(function() {
                            vm.busy = false;
                        }, 1000);
                    }
                    let Orders = result.Data.Orders;
                    vm.activitys = vm.activitys.concat(Orders);
                }
            );
        },
        openMemo(index, memo) {
            const vm = this;
            // const Memo = vm.$refs.memo[index];
            // Memo.classList.add("active");
            if (memo == null || memo == "") {
                memo = "暫無繳費資訊";
            }

            vm.$swal({
                title: "繳費資訊",
                type: "info",
                html: memo,
                confirmButtonText: "確定"
            });
        },
        printData(id) {
            const vm = this;
            vm.$swal({
        text: "請輸入抬頭，如未輸入則預設為會員名稱",
        input: 'text',
        confirmButtonText: "確定",
        confirmButtonColor: '#ee8b59'
      }).then((result) => {
        API.getPrintActivity({Id: id}).then(res => {
                if(res.Ok && !res.Message) {
          const data = res.Data;
          let tmpItems = '';
          let tmpResult = '';
          for (let i = 0; i < data.items.length; i++) {
            if(data.IsTOIS) {
              tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Title}<br>眼部炎症會員</td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Amount}</td>
      </tr>`
            }else {
              tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Title}</td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Amount}</td>
      </tr>`
            }
          }
          tmpResult = `<div>
          <img src="https://www.retina.org.tw/images/trslogo.png" alt="TRS" style="position: absolute;top: 0;left: 0;margin-top: 18px;width: 180px;">
  <img src="https://www.retina.org.tw/images/%E8%A6%96%E7%B6%B2%E8%86%9C%E9%86%AB%E5%AD%B8%E6%9C%83_%E6%94%B6%E6%93%9A%E5%B0%88%E7%94%A8%E7%AB%A0-01.png" alt="TRS" style="position: absolute;top: 0;left: 50%;transform: translateX(-50%);width: 110px;">
  <h1 style="text-align: center;font-size: 20pt;font-weight: bold;margin-bottom: 5px;letter-spacing: 10px;">中華民國視網膜醫學會</h1>
  <p style="text-align: center;font-size: 12pt;margin-bottom: 5px;margin-top: 0;">10048台北市常德街1號景福館2樓206室/電話:0965-106869</p>
  <h2 style="text-align: center;font-size: 16pt;font-weight: bold;margin-bottom: 5px;margin-top: 5px;">《收據》</h2>
  <p style="font-size: 9pt;">統一編號 : 31828080</p>
  <p style="font-size: 9pt;">立案字號 : 台內社字第1010115120號</p>
  <p style="font-size: 12pt;">繳費日期 :${data.OrderPayOn}</p>
  <table style="width: 100%;border-spacing: 0px;">
    <thead>
      <tr>
        <th style="text-align: left;font-size: 12pt;width: 60%;padding: 5px;">茲收到：${result.value?result.value:data.Name}</th>
        <th style="text-align: left;font-size: 12pt;width: 40%;padding: 5px;">會員編號：${data.MemberNumber?data.MemberNumber:''}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="text-align: center;background-color: #E1E2E4;font-size: 12pt;border: 1px solid #000;padding: 5px;">項目</td>
        <td style="text-align: center;background-color: #E1E2E4;font-size: 12pt;border: 1px solid #000;padding: 5px;">金額</td>
      </tr>
      ${tmpItems}
      <tr>
        <td></td>
        <td style="font-size: 12pt;padding: 5px;font-weight: bold;">總計： ${data.TotalAmount}整</td>
      </tr>
    </tbody>
    </table>
    <p style="text-align: center;font-size: 10pt;padding: 20px 0 10px 0;">※此收據請妥善保管，遺失恕不補發</p></div>`
    let printWindow = window.open('', '', 'height=400,width=800');
    printWindow.document.write(tmpResult);
          printWindow.document.close();
          setTimeout(() => {
            printWindow.print();
          },1000);
        }else {
          vm.$swal({
          type: "warning",
          text: "請稍後再試。",
          confirmButtonText: "確定"
        });
        }
            })
      })
        }
    },
    computed: {
        who() {
            const vm = this;
            let Type = vm.memberInfo.SelectedFee;
            let ans = "";
            if (Type == 0) {
                ans = "視網膜付費會員";
            } else if (Type == 1) {
                ans = "眼科專科醫師";
            } else if (Type == 2) {
                ans = "住院醫師、研究醫師、學生";
            }
            // console.log(ans);
            return ans;
        }
    },
    created() {
        const vm = this;
        let Params = Common.GetUrlParams('Id');
        // console.log(Params);
        if (Params !== null) {
            vm.eventId = Params;
            // vm.eventDetail = {
            //     Participant: {
            //         IsValueCreated: true,
            //         Value: {
            //             Title: "研究生",
            //             Name: "邱彥齊",
            //             EngName: "Dio",
            //             Telephone: "",
            //             Mobile: "0975141773",
            //             Email: "yanjai802@gmail.com",
            //             Affiliation: "傑菲特",
            //             Position: "工程師",
            //             ZipCode: "",
            //             Address: "",
            //             SelectedFee: 0,
            //             IsVegetarian: false,
            //             IsAttendDinner: true,
            //             ActivityId: "01efe568-a224-42d6-8f7f-b0da32459a4d",
            //             Companions: [
            //                 {
            //                     Title: "研究生",
            //                     Name: "朋友",
            //                     EngName: "friend",
            //                     IsVegetarian: false,
            //                     IsAttendDinner: true
            //                 }
            //             ]
            //         }
            //     },
            //     Id: 3,
            //     Number: "RSAT000000003",
            //     IsPaid: false,
            //     TotalAmount: 1400,
            //     Title: "107年第一次Retina Club 學術演講會 - 報名開始囉!!",
            //     Image:
            //         "https://retinasociety.blob.core.windows.net/activity/01efe568-a224-42d6-8f7f-b0da32459a4d/1192235a739d4feeb8efeb7c3a3b39c5.jpg",
            //     Location: "隔壁家",
            //     Organizer: "我家",
            //     CoOrganizer: "他家",
            //     StartOn: "2019-08-20T00:00:00",
            //     EndOn: "2019-09-01T00:00:00"
            // };
            // vm.memberInfo = vm.eventDetail.Participant.Value;
            API.getActivityQrderDetail({ Id: vm.eventId }).then(res => {
                if (res.Ok) {
                    vm.eventDetail = res.Data;
                    vm.memberInfo = res.Data.Participant.Value;
                } else {
                    location.href = "/";
                }
            });
        }
        if (process.env.NODE_ENV === "production") {
            //page頁獲取資料
            let obj = JSON.parse(vm.propactivityorders);
            vm.activitys = obj.Orders; //寫入資料
            vm.Totalpage = Math.ceil(parseInt(obj.Total) / vm.Count); //計算總頁數
        }
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
#memberact .content {
    border: 8px solid #eee;
    padding: 20px;
    color: #666;
}
#memberact .remark {
    padding: 60px 0;
    text-align: center;
    font-size: 1.1rem;
    font-weight: 600;
}
#memberact .content .box .item {
    display: flex;
    /* align-items: center; */
    text-decoration: none;
    color: #666;
    flex-wrap: wrap;
    padding: 20px 0;
}
#memberact .content .box .item + .item {
    border-top: 1px solid #eee;
}
#memberact .content .box .item .img {
    width: 200px;
    font-size: 0;
}
#memberact .content .box .item .img img {
    width: 100%;
}
#memberact .content .box .item .info {
    padding: 0 10px;
    width: calc(80% - 200px);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
    letter-spacing: 2px;
    line-height: 1.5;
}
#memberact .content .box .item .info > div {
    width: 100%;
}
#memberact .content .box .item .btn_box {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
}
#memberact .content .box .item .memo {
    line-height: 1.5;
    letter-spacing: 2px;
    height: 0;
    overflow: hidden;
    transition: 0.5s;
}
#memberact .content .box .item .memo.active {
    padding: 10px 0;
    height: 60px;
}
#memberact .content .detail .act,
#memberact .content .detail .member,
#memberact .content .detail .friend,
#memberact .content .detail .cost {
    padding: 0 16px;
    letter-spacing: 2px;
    line-height: 1.5;
    margin-bottom: 20px;
}
#memberact .content .detail .act .title {
    font-size: 1.4rem;
    margin: 15px 0;
}
#memberact .content .detail .act .info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
#memberact .content .detail .act .info .img,
#memberact .content .detail .act .info .text {
    width: 49%;
    font-size: 0;
    max-height: 315px;
}
#memberact .content .detail .act .info .img img {
    width: 100%;
    height: 100%;
}
#memberact .content .detail .act .info .text {
    font-size: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
#memberact .content .detail .act .info .btn_box {
    padding: 20px 0;
    margin: 50px auto 0;
    width: 30%;
}
#memberact .content .detail .friend .item {
    border: 1px solid #eee;
    margin: 15px auto;
}
#memberact .content .detail .friend .item .title {
    background-color: #eee;
    padding: 8px 16px;
}
#memberact .content .detail .cost .title {
    background-color: #eee;
    padding: 8px 16px;
    margin: 5px auto 15px;
    text-align: right;
}
#memberact .content .detail .cost .signtpye {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
#memberact .content .detail .cost .signtpye li {
    /* padding: 8px 16px; */
    padding: 8px 0;
    display: flex;
}
#memberact .content .detail .cost .signtpye li > span:nth-child(1) {
    margin-right: 16px;
}
#memberact .content .detail .cost .signtpye li > span:nth-child(2),
#memberact .content .detail .total > span:nth-child(2) {
    min-width: 100px;
    text-align: right;
}
#memberact .content .detail .total {
    display: flex;
    justify-content: flex-end;
    padding: 8px 32px;
    letter-spacing: 2px;
    color: #f00;
}
#memberact .content .detail .total > span:nth-child(1) {
    margin-right: 16px;
}
/* Golbal css */
.text_span {
    display: flex;
    align-items: center;
    width: 50%;
    margin: auto;
    padding: 10px 0;
}
.text_span > span:nth-child(1) {
    width: 150px;
    text-align: right;
    margin-right: 20px;
}

@media screen and (max-width: 767px) {
    #memberact .content {
        padding: 20px 10px;
    }
    #memberact .content .box .item .img {
        width: 100%;
    }
    #memberact .content .box .item .info {
        padding: 10px 0;
        width: 100%;
    }
    #memberact .content .box .item .info > div {
        padding: 5px 0;
    }
    #memberact .content .box .item .btn_box {
        width: 165px;
        margin: auto;
    }
    #memberact .content .detail .act,
    #memberact .content .detail .member,
    #memberact .content .detail .friend,
    #memberact .content .detail .cost {
        padding: 0;
    }
    #memberact .content .detail .cost {
        margin: 20px auto 0;
    }
    #memberact .content .detail .act .info .img,
    #memberact .content .detail .act .info .text {
        width: 100%;
        padding: 8px 0;
    }
    #memberact .content .detail .act .info .text li {
        padding: 5px 0;
    }
    #memberact .content .detail .act .info .btn_box {
        width: 100%;
        margin: 10px auto 0;
    }
    #memberact .content .detail .friend .item .text_span {
        padding: 10px 16px;
    }

    #memberact .content .detail .cost .signtpye {
        align-items: flex-start;
    }
    #memberact .content .detail .cost .signtpye li {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding: 8px 16px;
    }
    #memberact .content .detail .total {
        padding: 8px 16px;
        text-align: left;
        justify-content: flex-start;
    }
    #memberact .content .detail .cost .title {
        text-align: left;
    }
    /* global CSS */
    .text_span {
        width: 100%;
    }
    .text_span > span:nth-child(1) {
        width: 110px;
        text-align: left;
        margin-right: 0;
    }
}

.btn_box {
    flex-direction: column;
}

#memberact .content .box .item+.item.print {
    border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/memberAct.vue